import axios from 'axios';
import Clipboard from 'clipboard';
import currencyJS from 'currency.js';
import Cookies from 'js-cookie';
import linkify from 'linkify-it';
import moment from 'moment';
import Papa from 'papaparse';
import { Fragment } from 'react';
import { useLocation } from 'react-router-dom';
import iconInstagram from '../assets/images/png/ic-instagram-32@2x.png';
import imgLivechat from '../assets/images/png/ic_webchat@2x.png';
import fb from '../assets/images/svg/fb.svg';
import imgWhatsapp24 from '../assets/images/svg/ic_WhatsApp_24.svg';
import line from '../assets/images/svg/line.svg';
import config from './config';
import { PlatformType } from './types';

const linkifyInstance = linkify();

export const HASHTAG = '<%=name%>';
export const HASHTAG_REGEX = new RegExp(HASHTAG, 'g');

export const doPercentage = (num, total) => {
  return (((num || 0) / (total || 0) || 0) * 100).toFixed(1);
};

export function parseJwt(token) {
  if (token) {
    const base64Url = token.split('.')[1];
    if (base64Url) {
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(c => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
          .join(''),
      );

      return JSON.parse(jsonPayload);
    }
  }
  return {};
}

export const mobileAndTabletCheck = () => {
  let check = false;
  (a => {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a,
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
        a.substr(0, 4),
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

export const timeout = ms => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

export const emailValid = email => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

export const dateFormat = (time, format) => moment(time, 'X').format(format);

const isTodayDateFormat = (time, type = '') => {
  const today = moment().startOf('day');
  if (today.isSame(time, 'day')) {
    return dateFormat(time, 'HH:mm');
  }
  if (type === 'customer') {
    return dateFormat(time, 'YYYY-MM-DD');
  }
  return dateFormat(time, 'YYYY-MM-DD HH:mm');
};

export const delay = ms =>
  new Promise(resolve => setTimeout(() => resolve('timeout'), ms));

const copyToClipboard = (text, callback) => {
  const button = document.createElement('button');
  button.setAttribute('data-clipboard-text', text);
  button.setAttribute('class', 'copyToClipboard-temp-button');
  document.body.appendChild(button);
  const clipboard = new Clipboard('.copyToClipboard-temp-button');
  clipboard.on('success', e => {
    if (callback) callback();
    e.clearSelection();
  });
  button.click();
  document.body.removeChild(button);
  clipboard.destroy();
};

function createKey(key) {
  return key;
}

export function stringWithNewLine(str, reactKey) {
  return str.split('\n').map((subString, index) => (
    <Fragment key={`${reactKey}-${createKey(index)}`}>
      {subString}
      <br />
    </Fragment>
  ));
}

export function TWD(value, formatWithSymbol = true) {
  const currency = currencyJS(value, { precision: 0, formatWithSymbol });
  const result = formatWithSymbol
    ? currency.format()
    : currency.format({ symbol: '' });
  currency.format = () => result;
  return currency;
}

export function sendOriginalFormRequest(
  method = 'GET',
  action = '/',
  inputData = {},
) {
  const form = document.createElement('form');
  form.method = method;
  form.action = action;
  Object.keys(inputData).forEach(key => {
    const hiddenField = document.createElement('input');
    hiddenField.type = 'hidden';
    hiddenField.name = key;
    hiddenField.value = inputData[key];

    form.appendChild(hiddenField);
  });
  document.body.appendChild(form);
  form.submit();
}

export function transformTagsToString(tags) {
  return tags.reduce((pre, tag, index) => {
    if (index === 0) {
      return `${pre}「${tag}」`;
    }
    return `${pre}、「${tag}」`;
  }, '');
}

/**
 *
 * @param {string} text
 */
export function tranformToRegex(text) {
  let output = '';
  for (let i = 0; i < text.length; i += 1) {
    switch (text[i]) {
      case '\\':
        output += '\\\\';
        break;
      case '^':
        output += '\\^';
        break;
      case '$':
        output += '\\$';
        break;
      case '(':
        output += '\\(';
        break;
      case ')':
        output += '\\)';
        break;
      case '[':
        output += '\\[';
        break;
      case ']':
        output += '\\]';
        break;
      case '*':
        output += '\\*';
        break;
      case '+':
        output += '\\+';
        break;
      case '?':
        output += '\\?';
        break;
      case '.':
        output += '\\.';
        break;
      default:
        output += text[i];
    }
  }
  return output;
}

export function simpleHash(input) {
  let hash = 0;
  let i = 0;
  let chr = null;
  for (i = 0; i < input.length; i += 1) {
    chr = input.charCodeAt(i);
    // eslint-disable-next-line no-bitwise
    hash = (hash << 5) - hash + chr;
    // eslint-disable-next-line no-bitwise
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
}

export function validateHttpsPath(path) {
  return /^((http|https):\/\/)([\w.]+\/?)\S*/g.test(path);
}

export function validateHttpsAndHttpPath(path) {
  return /^((http|https):\/\/)([\w.]+\/?)\S*/g.test(path);
}

export function validateNo8Path(path) {
  return /^(no8:\/\/)([\w.]+\/?)\S*/g.test(path);
}

export function validateLinePath(path) {
  return /^(line:\/\/)([\w.]+\/?)\S*/g.test(path);
}

export function scrollToWithAnimation(element, to, duration) {
  const start = element.scrollTop;
  const change = to - start;
  let currentTime = 0;
  const increment = 20;

  const animateScroll = () => {
    currentTime += increment;
    const val = Math.easeInOutQuad(currentTime, start, change, duration);
    // eslint-disable-next-line no-param-reassign
    element.scrollTop = val;
    if (currentTime < duration) {
      setTimeout(animateScroll, increment);
    }
  };
  animateScroll();
}

export function dataURLtoFile(dataurl, filename) {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  const n = bstr.length;
  const u8arr = new Uint8Array(n);
  for (let i = 0; i < n; i += 1) {
    u8arr[i] = bstr.charCodeAt(i);
  }
  return new File([u8arr], filename, { type: mime });
}

// t = current time
// b = start value
// c = change in value
// d = duration

Math.easeInOutQuad = (t, b, c, d) => {
  // eslint-disable-next-line no-param-reassign
  t /= d / 2;
  if (t < 1) return (c / 2) * t * t + b;
  // eslint-disable-next-line no-param-reassign
  t -= 1;
  return (-c / 2) * (t * (t - 2) - 1) + b;
};

export function transformPhone(phone) {
  if (phone[0] === '0') {
    return `+886${phone.slice(1)}`;
  }
  return phone;
}

export function validatePhone(phone) {
  if (phone[0] === '+') return true;
  return false;
}

export function clearArray(array) {
  while (array.length > 0) {
    array.pop();
  }
}

const mailRegex = new RegExp(
  '^([a-z0-9_-]+(\\.|\\+))*[a-z0-9_-]+@[a-z0-9_-]+(\\.[a-z0-9_-]+)*\\.[a-z]{2,6}$',
);

const fileNameRegex = new RegExp(
  '^[\u4e00-\u9fa5A-Za-z0-9\u3001-\u3003\uff1f\uff0c\\w]+$',
);

const cellPhoneRegex = new RegExp(/^[\\+\-0-9]*$/);

export function validateDate(start, end) {
  return !!start && !!end && moment(end).isSameOrAfter(start, 'minute');
}

export function validateExcelSheetName(text) {
  return !text.match(/\/|\\|\?|\*|\[|\]/g);
}

export function validateText(text) {
  return !!text;
}

export function validateKeywords(keywords) {
  const temp = (keywords || []).filter(k => !!k);
  return !!(temp && temp.length);
}

export function validateEmail(email) {
  return mailRegex.test(email);
}

export function validateInteger(val) {
  // eslint-disable-next-line eqeqeq
  if (val != parseInt(val, 10)) {
    return false;
  }
  if (Number.isNaN(val)) {
    return false;
  }
  const x = parseFloat(val);
  return (x || 0) === x;
}

export function validateMax(text, num) {
  return text && text.length <= num;
}

export function validateMin(text, num) {
  return text && text.length >= num;
}

export function validateFileName(name) {
  return fileNameRegex.test(name);
}

export function validateCellPhone(value) {
  return cellPhoneRegex.test(value);
}

export const asyncForEach = async (array, callback) => {
  for (let index = 0; index < array.length; index += 1) {
    // eslint-disable-next-line no-await-in-loop
    await callback(array[index], index, array);
  }
};

export function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export function getSessionToken() {
  return (
    Cookies.get(config.SESSION_TOKEN_NAME) ||
    process.env.REACT_APP_SESSION_TOKEN ||
    undefined
  );
}

export const linkifyUrl = rawText => {
  if (typeof rawText !== 'string') {
    return { html: rawText };
  }

  const linkifyResult = linkifyInstance.match(rawText);

  const linkMap = [];

  const patternResult =
    linkifyResult &&
    linkifyResult.reduce((pre, current, idx) => {
      linkMap.push(
        `<a href='${linkifyResult[idx].url}' target='_blank'  class='textMessageLink'>${linkifyResult[idx].text}</a>`,
      );
      return pre.replace(linkifyResult[idx].text, `%{${idx}}%`);
    }, rawText);

  const htmlText =
    linkMap.length > 0
      ? linkMap.reduce((pre, current, idx) => {
          return pre.replace(`%{${idx}}%`, linkMap[idx]);
        }, patternResult)
      : rawText;

  return { html: htmlText };
};

export const showText = content => {
  let text = '';
  const res = linkifyUrl(content);
  if (res.html) {
    text = res.html;
  }
  if (text && text.length > 0) {
    text = text.replace(/(\r\n|\n|\r)/gm, '<br/>');
  }
  return text;
};

function validateImageCardData(cardData) {
  let totalImages = 0;
  let totalButtons = 0;
  for (let i = 0; i < cardData.length; i += 1) {
    const d = cardData[i];
    totalImages += d.imageUrl !== '' ? 1 : 0;
    totalButtons += d.buttons.length;

    if (d.imageType === 'url' && !validateHttpsPath(d.imageUrl)) {
      return false;
    }

    const button = d.buttons[0];
    if (
      button.type === 'postback' &&
      (button.title === '' ||
        button.title.length > config.MAX_BUTTON_TITLE_LENGTH)
    )
      return false;
    if (button.data === '' && button.type !== 'location') return false;
    if (
      button.type === 'url' &&
      !validateHttpsAndHttpPath(button.data) &&
      !validateNo8Path(button.data)
    ) {
      return false;
    }
    if (button.type === 'phone' && !validatePhone(button.data)) {
      return false;
    }
  }
  if (totalImages !== 0 && totalImages !== cardData.length) {
    return false;
  }
  if (totalButtons / cardData[0].buttons.length !== cardData.length) {
    return false;
  }
  return true;
}

export function validateCardData(cardData) {
  let totalImages = 0;
  let totalButtons = 0;
  for (let i = 0; i < cardData.length; i += 1) {
    const d = cardData[i];
    if (d.imageType === 'url' && !validateHttpsPath(d.imageUrl)) return false;
    if (d.title === '' || d.title.length > config.MAX_CARD_TITLE_LENGTH)
      return false;
    if (
      d.subtitle === '' ||
      d.subtitle.length > config.MAX_CARD_SUBTITLE_LENGTH
    )
      return false;
    totalImages += d.imageUrl !== '' ? 1 : 0;
    totalButtons += d.buttons.length;

    for (
      let buttonIndex = 0;
      buttonIndex < d.buttons.length;
      buttonIndex += 1
    ) {
      const button = d.buttons[buttonIndex];
      if (
        button.title === '' ||
        button.title.length > config.MAX_BUTTON_TITLE_LENGTH
      )
        return false;
      if (button.data === '' && button.type !== 'location') return false;
      if (
        button.type === 'url' &&
        !validateHttpsAndHttpPath(button.data) &&
        !validateNo8Path(button.data)
      ) {
        return false;
      }
      if (button.type === 'phone' && !validatePhone(button.data)) {
        return false;
      }
    }
  }
  if (totalImages !== 0 && totalImages !== cardData.length) {
    return false;
  }
  if (totalButtons / cardData[0].buttons.length !== cardData.length) {
    return false;
  }
  return true;
}

function validateConfirmCardData(cardData) {
  if (cardData.title === '') return false;
  for (let i = 0; i < cardData.buttons.length; i += 1) {
    if (
      cardData.buttons[i].title === '' ||
      cardData.buttons[i].title.length > 20
    )
      return false;
    if (cardData.buttons[i].type === 'postback') {
      if (
        cardData.buttons[i].data === '' ||
        cardData.buttons[i].data.length > 20
      )
        return false;
    }
    if (cardData.buttons[i].type === 'url') {
      if (
        cardData.buttons[i].data === '' ||
        (!validateHttpsAndHttpPath(cardData.buttons[i].data) &&
          !validateNo8Path(cardData.buttons[i].data))
      )
        return false;
    }
  }
  return true;
}

export const validateImagemapData = data => {
  if (!data.imageUrl) return false;
  for (let i = 0; i < data.buttons.length; i += 1) {
    const btn = data.buttons[i];
    if (!btn.data && btn.type !== 'location') return false;
    if (
      btn.type === 'url' &&
      !validateHttpsAndHttpPath(btn.data) &&
      !validateNo8Path(btn.data) &&
      !validateLinePath(btn.data)
    )
      return false;
  }
  return true;
};

export const validateMessages = messages => {
  let result = true;
  result = messages.reduce((pre, curr) => {
    if (curr.contentType === 'text/plain') {
      return pre && curr.data.content !== '';
    }
    if (
      curr.contentType === 'application/x-image' ||
      curr.contentType === 'application/x-audio' ||
      curr.contentType === 'application/x-video'
    ) {
      return pre && curr.data.url !== '';
    }
    if (curr.templateType === 'card' || curr.data.templateType === 'card') {
      return pre && validateCardData(curr.data.elements);
    }
    if (curr.templateType === 'image' || curr.data.templateType === 'image') {
      return pre && validateImageCardData(curr.data.elements);
    }
    if (
      curr.templateType === 'confirm' ||
      curr.data.templateType === 'confirm'
    ) {
      return pre && validateConfirmCardData(curr.data.elements[0]);
    }
    if (
      curr.templateType === 'imagemap' ||
      curr.data.templateType === 'imagemap'
    ) {
      return pre && validateImagemapData(curr.data.elements[0]);
    }
    return false;
  }, result);

  return result;
};

export const randomText = (len = 10) => {
  let text = '';
  const raw = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  for (let index = 0; index < len; index += 1) {
    text += raw.charAt(Math.floor(Math.random() * raw.length));
  }

  return text;
};

export const compress = (img, q = 0.8) => {
  const canvas = document.createElement('canvas');
  canvas.width = img.width;
  canvas.height = img.height;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0, img.width, img.height);

  return new Promise(resolve => {
    canvas.toBlob(resolve, 'image/jpeg', q);
    canvas.remove();
  });
};

export const handleGetCompressImage = eventFile => {
  return new Promise(resolve => {
    if (/^image\/(jpeg|jpg)/.test(eventFile.type)) {
      const img = new Image();
      img.src = URL.createObjectURL(eventFile);
      img.onload = async () => {
        const blob = await compress(img);
        if (blob.size < eventFile.size) {
          const newFile = new File([blob], eventFile.name, {
            type: eventFile.type,
          });
          resolve(newFile);
        } else {
          resolve(eventFile);
        }
      };
    } else {
      resolve(eventFile);
    }
  });
};

export function validateRecurringMessageContents(contents) {
  return contents?.elements?.every(
    e => validateText(e?.title) && validateMax(e?.title, 65),
  );
}

export const paserCsv = file => {
  return new Promise(resolve => {
    Papa.parse(file, {
      header: true,
      delimiter: ',',
      dynamicTyping: true,
      skipEmptyLines: true,
      complete: res => resolve(res || {}),
    });
  });
};

export const platformIconsSrc = {
  [PlatformType.FACEBOOK]: fb,
  [PlatformType.LINE]: line,
  [PlatformType.INSTAGRAM]: iconInstagram,
  [PlatformType.LIVECHAT]: imgLivechat,
  [PlatformType.WHATSAPP]: imgWhatsapp24,
};

export function validURL(str) {
  const pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$',
    'i',
  ); // fragment locator
  return !!pattern.test(str);
}

export const changeSeconds = (seconds = 0, changeType = 'minute') => {
  switch (changeType) {
    case 'second':
      return Math.floor(seconds % 60);
    case 'year':
      return Math.floor(seconds / 60 / 60 / 24 / 30 / 12);
    case 'month':
      return Math.floor((seconds / 60 / 60 / 24 / 30) % 12);
    case 'day':
      return Math.floor((seconds / 60 / 60 / 24) % 30);
    case 'hour':
      return Math.floor((seconds / 60 / 60) % 24);
    case 'minute':
    default:
      return Math.floor((seconds / 60) % 60);
  }
};

export async function downloadImage(file) {
  const fileName = file.replace(/^.*[\\/]/, '');
  const response = await axios.get(`${file}?time=${new Date().getTime()}`, {
    responseType: 'blob',
  });
  const imageURL = URL.createObjectURL(response.data);
  const link = document.createElement('a');
  link.href = imageURL;
  link.download = fileName;
  link.click();
}

export default {
  asyncForEach,
  dateFormat,
  delay,
  isTodayDateFormat,
  copyToClipboard,
  TWD,
  transformTagsToString,
};
